import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { formatCurrency } from 'legacy/utils/formatCurrency'

const appear = keyframes`
  0% {
    opacity: 0;
    line-height: 0;
    height: 0;
    padding: 0;
  }
  50% {
    height: 32px;
    line-height: 1;
    padding: 8px;
  }
  100% {
    opacity: 1;
  }
`

const Container = styled.div`
  width: 100%;
  max-height: 100%;
`

const Bids = styled.div`
  animation: ${appear} 500ms ease-in-out;
  background-color: ${getToken('color-danger-light')};
  color: ${getToken('color-danger-dark')};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  font-size: 13px;
  justify-content: center;
  padding: 8px;
`

const BidsPrice = styled.span`
  font-size: 13px;
  font-weight: 700;
`

export function BidHistory({ title = '', history, size = 2 }) {
  const bids = history
    .slice(0, size)
    .map(bid => {
      return formatCurrency(bid.price)
    })
    .join(', ')
  return (
    <Container>
      {Boolean(history.length) && (
        <Bids>
          {`${title}:`} &nbsp;
          <BidsPrice>{bids}</BidsPrice>
        </Bids>
      )}
    </Container>
  )
}

BidHistory.propTypes = {
  title: PropTypes.string,
  size: PropTypes.number,
  history: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      created_at: PropTypes.string,
      expires_at: PropTypes.string,
      expired_at: PropTypes.string,
    })
  ).isRequired,
}
